export const humanizeBoolean = (value: boolean): string =>
  value ? 'Available' : 'Not available'
